// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"fed8f83f","buttonRow":"d6ca3170","saveButtonContainer":"ce0c0a50","saveButton":"d0edea3e"};